import * as jose from 'jose';

export const createTestBearerToken = (additionalPayload = {}) => {
  const secret = 'ach-wie-gut-dass-niemand-weiss-9';
  const nowSec = Math.floor(Date.now() / 1000);
  const header = { alg: 'HS256', kid: 'test' };
  const payload = {
    iss: 'http://fake.issuer.for.coms.simulator.telefonica.de',
    iat: nowSec,
    exp: nowSec + 3600, // 1h
    sub: 'fake-customer',
    aud: 'coms.api.4p',
    scope: ['u-672:trusted'],
    ...additionalPayload,
  };
  const secretEncoded = new TextEncoder().encode(secret);
  return new jose.SignJWT(payload).setProtectedHeader(header).sign(secretEncoded);
};
